import { z } from 'zod';
import { FieldConfigurationSchema } from './custom-field.dto';
import { FeedbackFormFieldSchema } from './feedback-form.dto';

export const SaveDataSchema = z.object({
  values: z.array(z.string()),
  fieldConfiguration: FieldConfigurationSchema,
  isSystem: z.boolean().default(false).optional(),
});
export type SaveDataDto = z.infer<typeof SaveDataSchema>;

export const CustomFieldValueSchema = FeedbackFormFieldSchema.extend({
  saveData: SaveDataSchema,
});
export type CustomFieldValueDto = z.infer<typeof CustomFieldValueSchema>;
